const resetStyle = `
  /*==========reset.css==========*/
    html,
    body,
    div,
    span,
    object,
    iframe,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    blockquote,
    pre,
    abbr,
    address,
    cite,
    code,
    del,
    dfn,
    em,
    img,
    ins,
    kbd,
    q,
    samp,
    small,
    strong,
    sub,
    sup,
    var,
    b,
    i,
    dl,
    dt,
    dd,
    ol,
    ul,
    li,
    fieldset,
    form,
    label,
    legend,
    table,
    caption,
    tbody,
    tfoot,
    thead,
    tr,
    th,
    td,
    article,
    aside,
    canvas,
    details,
    figcaption,
    figure,
    footer,
    header,
    hgroup,
    menu,
    nav,
    section,
    summary,
    time,
    mark,
    audio,
    video,
    button {
      margin: 0;
      padding: 0;
      border: 0;
      outline: 0;
      font-size: 15px;
      vertical-align: baseline;
      background: transparent;
      font-family: "Noto Sans KR",'Apple SD Gothic Neo', sans-serif;
    }
    article,
    aside,
    details,
    figcaption,
    figure,
    footer,
    header,
    hgroup,
    menu,
    nav,
    section {
      display: block;
    }
    ul {
      list-style: none;
    }
    blockquote,
    q {
      quotes: none;
    }
    blockquote:before,
    blockquote:after,
    q:before,
    q:after {
      content: "";
      content: none;
    }
    a {
      margin: 0;
      padding: 0;
      font-size: 15px;
      vertical-align: baseline;
      background: transparent;
      text-decoration: none;
      color: #000;
    }
    a:hover {
      text-decoration: none;
    }
    
    /* change colours to suit your needs */
    ins {
      background-color: #ff9;
      color: #000;
      text-decoration: none;
    }
    /* change colours to suit your needs */
    mark {
      background-color: #ff9;
      color: #000;
      font-style: italic;
      font-weight: bold;
    }
    del {
      text-decoration: line-through;
    }
    abbr[title],
    dfn[title] {
      border-bottom: 1px dotted;
      cursor: help;
    }
    table {
      border-collapse: collapse;
      border-spacing: 0;
    }
    /* change border colour to suit your needs */
    hr {
      display: block;
      height: 1px;
      border: 0;
      border-top: 1px solid #cccccc;
      margin: 1em 0;
      padding: 0;
    }
    
    input,
    select {
      vertical-align: middle;
      appearance: none;
      -webkit-appearance: none;
      -webkit-border-radius: 0;
      background: none;
    }
    input::-webkit-credentials-auto-fill-button {
      visibility: hidden;
      pointer-events: none;
      position: absolute;
      right: 0;
    }
    
    button {
      border: none;
      outline: none;
      background: none;
      padding: 0;
    }
    button:focus {
      outline: none;
    }
    /*==========공통==========*/
    .jw-state-idle .jw-controls {
      background: rgba(0, 0, 0, 0) !important;
    }
    body {
      font-size: 15px;
      font-family: "Noto Sans KR",'Apple SD Gothic Neo', sans-serif;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
    }
    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-container-horizontal > .swiper-pagination-bullets {
      bottom: 10px;
      left: 0;
      width: 100%;
    }
    .swiper-pagination {
      position: absolute;
      text-align: center;
      transition: 300ms opacity;
      transform: translate3d(0, 0, 0);
      z-index: 10;
    }
    .swiper-container-horizontal
      > .swiper-pagination-bullets
      .swiper-pagination-bullet {
      margin: 0 4px;
    }
    .swiper-pagination-clickable .swiper-pagination-bullet {
      cursor: pointer;
    }
    .swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      display: inline-block;
      border-radius: 50%;
      background: #000;
      opacity: 0.2;
    }
    .wid_1180 {
      max-width: 1180px;
      margin: 0 auto;
    }
    .wid_1060{
      max-width:1060px;
      margin:0 auto;
      padding-bottom:100px;
    }
    .clear:after {
      content: "";
      display: block;
      clear: both;
    }
    textarea:focus-visible {outline:none;}
`;
export default resetStyle;